import React from 'react'
import { ProgressBar, Classes } from '@blueprintjs/core'
import { Dialog, IconButton, Confirmation } from '@ui'
import { UseEmployeesHook } from './hooks/useEmployees'
import useEmployeeExport from './hooks/useEmployeeExport'
import { animated, useSpring } from 'react-spring'

interface ExportEmployeesDialogProps {
  employees: UseEmployeesHook
  isOpen: boolean
  onClose: () => void
}

export default function ExportEmployeesDialog({
  employees,
  isOpen,
  onClose,
}: ExportEmployeesDialogProps) {
  const { progress } = useEmployeeExport(employees, onClose)
  const props = useSpring({ progress })

  return (
    <Dialog
      isOpen={isOpen}
      canEscapeKeyClose={false}
      canOutsideClickClose={false}
      isCloseButtonShown={false}
      transitionDuration={200}
      usePortal
      title="Export to CSV"
      toolbar={
        <div className="dialog-buttons">
          <Confirmation text="Cancel export?" onConfirm={onClose}>
            <IconButton minimal tooltip="Close" iconName="times" />
          </Confirmation>
        </div>
      }
      body={
        <div style={{ width: 470 }}>
          <ProgressBar value={progress} stripes={false} />
          <div style={{ marginTop: 5 }}>
            <animated.span>
              {props.progress.interpolate((x: any) => Math.round(x * 100))}
            </animated.span>
            % complete
          </div>
        </div>
      }
    />
  )
}
